import { render, staticRenderFns } from "./ArticalLayout.vue?vue&type=template&id=154b6942&scoped=true&"
import script from "./ArticalLayout.vue?vue&type=script&lang=js&"
export * from "./ArticalLayout.vue?vue&type=script&lang=js&"
import style0 from "./ArticalLayout.vue?vue&type=style&index=0&id=154b6942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154b6942",
  null
  
)

export default component.exports